var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('img',{attrs:{"src":("" + _vm.storageUrl + _vm.url),"alt":"sd"}}):_c('svg-icon',{attrs:{"name":"svg/user"}})}
var staticRenderFns = []

export { render, staticRenderFns }